export default __webpack_public_path__ + "static/media/slider4.e471ff40.svg";